import { categoryFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';
import gql from 'graphql-tag';

export const updateCategoryMutation = gql`
  mutation UpdateCategory($id: ID!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminCategoryFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${categoryFieldsFragment}
`;